import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "flex flex-col gap-4 text-left",
  "data-testid": "invite-sent-step"
}
const _hoisted_2 = { class: "flex items-start gap-3 bg-primary5 border border-primary/20 rounded-md px-4 py-3" }
const _hoisted_3 = { class: "text-sm text-textPrimary" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Convite enviado.", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-textPrimary" }, "Link do convite"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-[#68688D]" }, " Cada médico tem um link próprio. Copie e envie pelo canal que você já usa com o médico. ")
], -1)
const _hoisted_7 = { class: "list-none p-0 m-0 border border-gray-200 rounded-lg divide-y divide-gray-200" }
const _hoisted_8 = { class: "min-w-0" }
const _hoisted_9 = { class: "text-textPrimary truncate" }
const _hoisted_10 = { class: "text-xs text-[#68688D] break-all" }

import { useToast } from 'vue-toastification'
import { mdiCheckCircleOutline } from '@mdi/js'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { useErrorToast } from '@/composables/useErrorToast'
import { DESKTOP_MEDIA_QUERY, useMediaQuery } from '@/hooks/useMediaQuery'
import type { CreatedAllocationInviteLink } from '@/Network/Types/Responses/AllocationInviteResponses'


export default /*#__PURE__*/_defineComponent({
  __name: 'InviteSentStep',
  props: {
    links: {},
    doctorName: { type: Function },
    deadlineText: {}
  },
  setup(__props: any) {



const toast = useToast()
const { notifyErrorMessage } = useErrorToast()
// O OutlineButton fixa `width: 300px` inline no VBtn, que vence classes do Tailwind.
const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY)

/** Sem o protocolo, como no mockup. */
const displayUrl = (url: string) => url.replace(/^https?:\/\//, '')

// A cópia aqui não é auditada (plano WEB-1, P4): o link da criação é a única emissão.
async function copy(url: string) {
  try {
    await navigator.clipboard.writeText(url)
    toast.success('Link copiado.')
  } catch {
    notifyErrorMessage('Não foi possível copiar o link. Selecione e copie manualmente.')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, {
        icon: _unref(mdiCheckCircleOutline),
        color: "primary",
        class: "shrink-0 mt-0.5"
      }, null, 8, ["icon"]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", null, [
          _createTextVNode(" A vaga continua aberta até o primeiro aceite. "),
          (_ctx.deadlineText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "O convite vence em " + _toDisplayString(_ctx.deadlineText) + ".", 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_6,
    _createElementVNode("ul", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
        return (_openBlock(), _createElementBlock("li", {
          key: link.inviteeId,
          class: "flex flex-col md:flex-row md:items-center justify-between gap-3 px-4 py-3",
          "data-testid": "invite-link-row"
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.doctorName(link.doctorId)), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(displayUrl(link.url)), 1)
          ]),
          _createVNode(OutlineButton, {
            height: "40px",
            color: "primary",
            width: _unref(isDesktop) ? '150px' : '100%',
            class: "shrink-0",
            "data-testid": "copy-invite-link-button",
            onClick: ($event: any) => (copy(link.url))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Copiar link ")
            ]),
            _: 2
          }, 1032, ["width", "onClick"])
        ]))
      }), 128))
    ])
  ]))
}
}

})